<span class="card-image-overlay">
    <div class="card-image">
        <img [src]="cardInfo.imageUrl" alt="cardInfo.alt">
        <div class="card-image-footer">
          <div class="card-category bg-color-white">{{cardInfo.category}}</div>
          <h2 class="overlay-title">{{cardInfo.title}}</h2>
        </div>
    </div>
</span>